import { ParsedLocation, redirect } from '@tanstack/react-router'
import { RootStore } from '~/store/RootStore'

type IBeforeLoad = {
  context: {
    store: RootStore
  }
  location: ParsedLocation
}

export const checkMfaBeforeLoad = async ({
  context,
  location,
}: IBeforeLoad) => {
  const isMfaDone = context.store.app.isMfaDone
  if (!isMfaDone) {
    throw redirect({
      to: '/mfa',
      state: { path: location.pathname },
    })
  }
}
